export const messages = {
  text: {
    id: "group-resources.header.text",
    defaultMessage: "{{name}} ({{count}})",
  },
};
